import React from "react";
import { Star, Quote } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Testimonials() {
  const { site } = useSite();
  const items = site?.testimonials || [];
  if (items.length === 0) return null;

  return (
    <section
      data-testid="testimonials-section"
      id="testimonials"
      className="bg-neutral-100 py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="overline">Client Reviews</span>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-bold uppercase leading-tight tracking-tight">
            Homeowners <span className="text-[#DC2626]">love</span> the results
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <div
              key={t.id || i}
              data-testid={`testimonial-${i}`}
              className="bg-white p-8 border border-neutral-200 hard-shadow-hover relative"
            >
              <Quote size={40} className="text-[#DC2626] mb-4" strokeWidth={2} />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating || 5 }).map((_, j) => (
                  <Star key={j} size={16} className="text-[#DC2626]" fill="#DC2626" />
                ))}
              </div>
              <p className="text-neutral-800 leading-relaxed">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-6 pt-6 border-t border-neutral-200">
                <p className="font-heading font-bold uppercase tracking-tight text-neutral-900">
                  {t.name}
                </p>
                {t.location && (
                  <p className="text-xs uppercase tracking-widest text-neutral-500 mt-1">
                    {t.location}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
